/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 1 = ShowSubs

2 = NotifySubs

3 = ShowOwner

4 = NotifyOwner

5 = ShowBuilder

6 = NotifyBuilder

7 = MainFile


 */
export type FileOptions = (typeof FileOptions)[keyof typeof FileOptions];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FileOptions = {
  ShowSubs: 1,
  NotifySubs: 2,
  ShowOwner: 3,
  NotifyOwner: 4,
  ShowBuilder: 5,
  NotifyBuilder: 6,
  MainFile: 7,
} as const;
